import { MicrosoftAuthenticatorAuthenticationMethodConfiguration } from '@microsoft/microsoft-graph-types-beta';
import { AuthenticationMethodPolicyMicrosoftAuthenticatorSchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/authentication-method-policy/microsoft-authenticator/model';
import { updateAuthenticationMethodPolicyConfig } from 'projects/angular-clarity/src/app/stores/client/graph/authentication-methods-policies/actions';

export function remediate(
    _tenant: string,
    policy: MicrosoftAuthenticatorAuthenticationMethodConfiguration,
    schema: AuthenticationMethodPolicyMicrosoftAuthenticatorSchema,
) {
    const updatedPolicy: MicrosoftAuthenticatorAuthenticationMethodConfiguration = {
        ...policy,
        state: schema.properties.state.const,
        isSoftwareOathEnabled: schema.properties.isSoftwareOathEnabled.const,
    };

    if (schema.properties.includeTargets.maxItems > 0) {
        updatedPolicy.includeTargets = schema.properties.includeTargets.items.oneOf.map((target) => {
            return {
                id: target.properties.id.const,
                targetType: target.properties.targetType.const,
                authenticationMode: target.properties.authenticationMode.const,
            };
        });
    } else {
        updatedPolicy.includeTargets = [];
    }

    if (schema.properties.excludeTargets.maxItems > 0) {
        updatedPolicy.excludeTargets = schema.properties.excludeTargets.items.oneOf.map((target) => {
            return {
                id: target.properties.id.const,
                targetType: target.properties.targetType.const,
            };
        });
    } else {
        updatedPolicy.excludeTargets = [];
    }
    return updateAuthenticationMethodPolicyConfig({
        _tenant,

        policy: {
            ...updatedPolicy,
            featureSettings: {
                // ...updatedPolicy.featureSettings,
                companionAppAllowedState: {
                    state: schema.properties.featureSettings.properties.companionAppAllowedState.properties.state.const,
                    includeTarget: {
                        id: schema.properties.featureSettings.properties.companionAppAllowedState.properties
                            .includeTarget.properties.id.const,
                        targetType: 'group',
                    },
                    excludeTarget: {
                        id: schema.properties.featureSettings.properties.companionAppAllowedState.properties
                            .excludeTarget.properties.id.const,
                        targetType: 'group',
                    },
                },
                displayAppInformationRequiredState: {
                    state: schema.properties.featureSettings.properties.displayAppInformationRequiredState.properties
                        .state.const,
                    includeTarget: {
                        id: schema.properties.featureSettings.properties.displayAppInformationRequiredState.properties
                            .includeTarget.properties.id.const,
                        targetType: 'group',
                    },
                    excludeTarget: {
                        id: schema.properties.featureSettings.properties.displayAppInformationRequiredState.properties
                            .excludeTarget.properties.id.const,
                        targetType: 'group',
                    },
                },
                displayLocationInformationRequiredState: {
                    state: schema.properties.featureSettings.properties.displayLocationInformationRequiredState
                        .properties.state.const,
                    includeTarget: {
                        id: schema.properties.featureSettings.properties.displayLocationInformationRequiredState
                            .properties.includeTarget.properties.id.const,
                        targetType: 'group',
                    },
                    excludeTarget: {
                        id: schema.properties.featureSettings.properties.displayLocationInformationRequiredState
                            .properties.excludeTarget.properties.id.const,
                        targetType: 'group',
                    },
                },
            },
        },
    });
}
